import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  progress: PropTypes.number
};

const defaultProps = {};

export default class QuestionnaireProgressBar extends React.Component {
  render() {
    return (
      <div className="rec-questionnaire-progress">
        <div className="questionnaire-progress-wrapper">
          <div className="questionnaire-progress" style={{ width: `${this.props.progress}%` }} />
        </div>
      </div>
    );
  }
}

QuestionnaireProgressBar.propTypes = propTypes;
QuestionnaireProgressBar.defaultProps = defaultProps;
